import React from 'react';

import PropTypes from 'prop-types';
import classNames from 'classnames/bind';

import { Button } from '@beef/ui-kit';
import { BUTTON_CAPTION } from 'constants/common';

import styles from './styles.pcss';

const cx = classNames.bind(styles);

export const ControlsSection = ({
  saveButtonDisabled,
  onSave,
  isSaveLoading,
}) => (
  <div className={cx('control-save-button')}>
    <Button
      size="l"
      fullWidth
      disabled={saveButtonDisabled}
      onClick={onSave}
      isLoading={isSaveLoading}
    >
      {BUTTON_CAPTION.SAVE}
    </Button>
  </div>
);

ControlsSection.propTypes = {
  isSaveLoading: PropTypes.bool,
  saveButtonDisabled: PropTypes.bool,
  onSave: PropTypes.func,
};
